// extracted by mini-css-extract-plugin
module.exports = {"centered":"Default_centered__MI5Cs"};